import { Heatmap } from 'modules/arena/reports/model/bodies';
import { formatPercent } from 'modules/arena/reports/model/format';
import { SEQUENTIAL_BRAND } from 'shared/constants/chartPalette';

function stepFor(value: number) {
  return Math.min(SEQUENTIAL_BRAND.length - 1, Math.floor((value / 100) * SEQUENTIAL_BRAND.length));
}

// Hachurado para fechado/bloqueado/sem aulas: nunca parece uma vaga livre (0%).
const HATCH = 'repeating-linear-gradient(135deg, #f1f5f9 0 6px, #e2e8f0 6px 8px)';

export function OccupancyHeatmap({ heatmap, caption }: { heatmap: Heatmap; caption: string }) {
  return (
    <div>
      <div className="overflow-x-auto">
        <table className="w-full min-w-[420px]" style={{ borderSpacing: 4, borderCollapse: 'separate' }}>
          <caption className="sr-only">{caption}</caption>
          <thead>
            <tr>
              <th scope="col" />
              {heatmap.columns.map((column) => (
                <th key={column} scope="col" className="pb-1 text-xs font-medium text-ink-secondary">
                  {column}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {heatmap.rows.map((row, rowIndex) => (
              <tr key={row}>
                <th scope="row" className="pr-2 text-left text-xs font-medium text-ink-secondary">
                  {row}
                </th>
                {heatmap.cells[rowIndex].map((cell, columnIndex) => {
                  const label = `${row}, ${heatmap.columns[columnIndex]}: ${cell.state === 'ok' ? formatPercent(cell.value) : cell.detail}`;
                  if (cell.state !== 'ok' || cell.value === null) {
                    return (
                      <td key={columnIndex}>
                        <div
                          className="flex h-10 items-center justify-center rounded-md text-[10px] font-medium text-ink-secondary"
                          style={{ backgroundImage: HATCH }}
                          title={label}
                          aria-label={label}
                        >
                          {cell.state === 'closed' ? cell.detail : '—'}
                        </div>
                      </td>
                    );
                  }
                  const step = stepFor(cell.value);
                  return (
                    <td key={columnIndex}>
                      <div
                        className="flex h-10 items-center justify-center rounded-md text-xs font-semibold"
                        style={{ backgroundColor: SEQUENTIAL_BRAND[step], color: step > 4 ? '#fff' : '#0f172a' }}
                        title={`${label} · ${cell.detail}`}
                        aria-label={`${label} · ${cell.detail}`}
                      >
                        {Math.round(cell.value)}%
                      </div>
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="mt-3 flex flex-wrap items-center gap-4 text-xs text-ink-secondary">
        <span className="flex items-center gap-2">
          Menor
          <span className="flex h-2 w-24 overflow-hidden rounded-full">
            {SEQUENTIAL_BRAND.map((color) => (
              <span key={color} className="h-full flex-1" style={{ backgroundColor: color }} />
            ))}
          </span>
          Maior ocupação
        </span>
        <span className="flex items-center gap-1.5">
          <span className="h-3 w-5 rounded-sm" style={{ backgroundImage: HATCH }} />
          Fechado, bloqueado ou sem atividade (não é vaga livre)
        </span>
      </div>
    </div>
  );
}
